module.exports = __webpack_public_path__ + "img/live-cards-mob.c3eaa49.gif";